<template>
    <section>
        <div v-show="showlist">
        <sy-baselist
                ref="list"
                :filters="filters"
                editVue="business/ProjectMould_Edit.vue"
                listUrl="server/business/ProjectMould.ashx?cmd=GetList"
                deleteUrl="server/business/ProjectMould.ashx?cmd=Delete"
                :pageSize="20"
                DelTips="该项目模板相关的所有模板将会被同时删除，确定删除吗？"
        >
            <el-table-column prop="FName" label="项目模板名称" width="250">
            </el-table-column>
              <el-table-column prop="FLeaderName" label="负责人" width="120">
            </el-table-column>
            <el-table-column prop="FCreateTime" label="创建时间" :formatter="formatDate" width="140" sortable>
            </el-table-column>
            <el-table-column prop="UserName" label="创建人" width="120">
            </el-table-column>
            <el-table-column prop="FNote" label="备注">
            </el-table-column>
            <template scope="props" slot="extendbtn">
                <el-button size="mini" class="el-icon-plus el-button el-button--text el-button--mini"  @click="showdetails(props.row)">模板管理</el-button>
            </template>
        </sy-baselist>
        </div>
        <div v-show="showdetail">
            <el-row>
            <el-col  class="toolbar">
                <el-form>
                    <el-form-item>
                        <el-tag  type="gray">{{joblist.length>0?joblist[0].FName:''}}</el-tag>
                        <a @click="showlists" style="color:#409EFF;margin-left: 20px;cursor:pointer;">&lt; 返回</a>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
            <template v-if="false">
                <el-table ref="table" :data="joblist">
                    <el-table-column prop="FName" label="项目模板名称" width="250" >
                    </el-table-column>
                </el-table>
            </template>
        <el-row :gutter="20">
            <el-col :span="24">
                <sy-baselist
                        ref="jobPhoto"
                        :autoSearch="false"
                        title="模板信息"
                        @beforeAdd="beforeAddDetail"
                        :pageSize="100"
                        editVue="business/ProjectMouldDetail_Edit.vue"
                        listUrl="server/business/ProjectMould.ashx?cmd=GetDetailList"
                        deleteUrl="server/business/ProjectMould.ashx?cmd=DeleteDetail"
                >
                    <el-table-column prop="FName" label="阶段" width="300">
                    </el-table-column>
                      <el-table-column prop="FLeaderName" label="负责人" width="120">
                    </el-table-column>
                    <el-table-column prop="FIsTask" label="是否目录" :formatter="formatIsTask" width="100">
                    </el-table-column>
                    <el-table-column prop="FNote" label="备注">
                    </el-table-column>
                     <template scope="props" slot="extendbtnTop">
                       <el-button size="mini"  class="el-icon-plus el-button el-button--text el-button--mini"  @click="showimportdetail()">导入</el-button>
                    </template>
                     <template scope="props" slot="extendbtn">
                       <el-button size="mini" v-if="showbtn(props.row)" class="el-icon-plus el-button el-button--text el-button--mini"  @click="addchild(props.row)">添加子级</el-button>
                       <el-button size="mini" v-if="showprint(props.row)" class="el-icon-plus el-button el-button--text el-button--mini"  @click="printmould(props.row)">打印模板</el-button>
                   </template>
                </sy-baselist>
            </el-col>
        </el-row>
        <editform ref="editforms"></editform>
        <detailimport  @onImportDetailSuc="importDetailfinish" ref="detailimport"></detailimport>
        </div>
    </section>
</template>

<script>
  import Vue from 'vue'
    import util from '../../common/util'
    import mixin from '../../common/mixin'
    import editform from '../business/ProjectMouldDetail_Edit.vue'
    import detailimport from './ProjectMouldDetail_Import.vue'
    export default {
         components: { editform, detailimport},
        mixins: [mixin],
        data(){
            return {
                jobID:0,
                jobRow:{},
                filters: [
                    {type: "string",name:"FName",text:"项目模板名称", value: null}
                ],
                showlist:true,
                showdetail:false,
                joblist:[]
            }
        },
        methods:{
            showdetails(row){
                this.jobID = row.FID
                this.jobRow =row
                this.showlist=false
                this.showdetail=true
                this.joblist=[]
                this.joblist.push(this.jobRow)
                this.$refs.jobPhoto._search("","FMouldId="+this.jobID)
            }, 
            beforeAddDetail(row,r){
                if(this.jobID==0) {
                    return r.error = "请先选择项目模板";
                }
                row.FJobID = this.jobID
            },
            addchild(row){
                  row.FJobID = this.jobID
                  row.PID = row.FID
                  this.createEditForm()._openAdd(row)
            },
            showlists(){
                this.showdetail=false
                this.showlist=true
            },
            onSaveSuc:function (row) {
                this.$refs.jobPhoto._search("","FMouldId="+this.jobID)
            },
            showimportdetail(){
            this.$refs.detailimport._open(this.jobID)
            },
            importDetailfinish(){
            this.$refs.jobPhoto._search("","FMouldId="+this.jobID)
            },
            formatIsTask(row){
                return row.FIsTask==1?'节点':'目录'
            },
            showbtn(row){
                if(row.FParentId!=0||row.FIsTask==1){
                    return false
                }
                return true
            },
            showprint(row){
                if(row.FIsTask==0){
                    return false
                }
                return true
            },
            printmould(row){
                window.open(global.serverHost + "client/print/dutyMoudlePrint.html?mouleId="+row.FID)
            },
             createEditForm(){
                debugger
                let C = Vue.extend(require("@/pages/business/ProjectMouldDetail_Edit.vue").default)
                let form = new C()
                form.$on("onSaveSuc", this.onSaveSuc)
                this.$el.appendChild(form.$mount().$el)
                if(this.reuseEditForm){
                  this.EditForm = form
               }else if(form.$children[0] && form.$children[0].$on){
                  //form子组件为el-dialog
                  //这里要销毁，以免使用相同窗体，状态保留出错
                  form.$children[0].$on("close",()=>{
                    form.$destroy(true);
                    this.$el.removeChild(form.$el);
                  })
                }
                return form
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/business/ProjectMould.vue